import { ColumnDef } from '@tanstack/react-table'
import { GetDailyCheckInDataResponse } from '@/modules/promotion/type'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { Pencil } from 'lucide-react'
import { IsActiveDailyCheckIn } from './CellAction/components/IsActiveDailyCheckIn'
import { Badge } from '@/common/ui/badge'

export const columns: ColumnDef<GetDailyCheckInDataResponse>[] = [
	{
		accessorKey: 'name',
		header: 'ชื่อรายการ',
		cell: ({ row }) => <p className="font-medium">{row.original.name}</p>,
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => (
			<Badge variant={row.original.isActive ? 'default' : 'secondary'}>
				{row.original.isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}
			</Badge>
		),
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง/แก้ไข',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p>สร้าง: {new Date(row.original.createdAt).toLocaleString()}</p>
				<p className="font-medium">
					แก้ไข: {new Date(row.original.updatedAt).toLocaleString()}
				</p>
			</div>
		),
	},
	{
		id: 'actions',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<IsActiveDailyCheckIn row={row.original} />
				<Link to={`/operator/daily-check-in/${row.original.id}`}>
					<Button variant="ghost" size="icon">
						<Pencil className="h-4 w-4" />
					</Button>
				</Link>
			</div>
		),
	},
]

export const writeAccessorKeys = ['actions']
